import React from "react";
import { Box } from "@mui/material";

const RotatingDotsSpinner = () => {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        marginTop:"10px"
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "40px",
          height: "40px",
          animation: "rotate-spinner 0.3s circle infinite",
        }}
      >
        {[...Array(8)].map((_, i) => (
          <Box
            key={i}
            sx={{
              position: "absolute",
              width: "8px",
              height: "8px",
              backgroundColor: "#0C359E",
              borderRadius: "45%  45% 45% 45%",
              top: "50%",
              left: "50%",
              transform: `rotate(${i * 45}deg) translate(16px)`,
              animation: "fade-spinner 1s linear infinite",
              animationDelay: `${i * 0.15}s`,
            }}
          />
        ))}
      </Box>

      <style>
        {`
          @keyframes rotate-spinner {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          @keyframes fade-spinner {
            0% { opacity: 1; }
            100% { opacity: 0.3; }
          }
        `}
      </style>
    </Box>
  );
};

export default RotatingDotsSpinner;

